module.exports = "/shared/img/dog-racing.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/dog-racing.png
// module id = 204
// module chunks = 13